import React from "react"
import { Helmet } from "react-helmet"
import { ColorPalette } from "../components/Theme"
// import ContactForm from "./ContactForm"

/** svg */
import EqualHousingIcon from "../../assets/equal-housing-icon.svg"
import HeartIcon from "../../assets/footer-heart-icon.svg"
import YouTubeIcon from "../../assets/youtube-icon.svg"
import LinkedInIcon from "../../assets/linkedin-icon.svg"
import InstagramIcon from "../../assets/instagram-icon.svg"
import TwitterIcon from "../../assets/twitter-icon.svg"
import FacebookIcon from "../../assets/facebook-icon.svg"
import ContactPhoneIcon from "../../assets/footer-contact-phone.svg"
import MailIcon from "../../assets/footer-mail-icon.svg"
import ClockIcon from "../../assets/footer-clock-icon.svg"
import ApartmentIcon from "../../assets/footer-apartment-icon.svg"
import NorhartDarkCircleIcon from "../../assets/norhart-dark-circle-icon.svg"
import NorhartTopWorkPlaces from "../../assets/top-work-places.svg"

/** props */
interface Props {
  colorPalette: ColorPalette
}

/** const */
const Footer: React.FC<Props> = (props) => {
  const getCurrentYear = () => {
    return new Date().getFullYear()
  }

  return (
    <div>
      <footer className="container py-5 d-none d-sm-block pb-0">
        <div className="row">
          <div className="col-3 col-md">
            <h3 className="footerHeader">Rent Today</h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="https://norhart.twa.rentmanager.com/applynow" target="_blank">
                    Apply Online
                  </a>
                </h4>
              </li>
            </ul>

            {/* <h3 className="mt-4 footerHeader">
              <a href="/oakdale/" target="_blank" style={{ color: "#FFFFFF", textDecoration: "none" }}>
                Locations
              </a>
            </h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/oakdale/">
                    Oakdale
                  </a>{" "}
                  <span
                    className="badge"
                    style={{
                      backgroundColor: "#ffffff",
                      color: "#111111",
                      fontSize: "0.7rem",
                    }}
                  >
                    New
                  </span>
                </h4>
              </li>
            </ul> */}

            {/* <h3 className="mt-4 footerHeader">
              <a href="/oakdale/" target="_blank" style={{ color: "#FFFFFF", textDecoration: "none" }}>
                Pre-Lease
              </a>
            </h3>

            <h4 className="footerNavSpace">
              <a className="footerLink" href="/oakdale/">
                Oakdale
              </a>{" "}
              <span
                className="badge"
                style={{
                  backgroundColor: "#ffffff",
                  color: "#111111",
                  fontSize: "0.7rem",
                }}
              >
                New
              </span>
            </h4> */}

            <h3 className="mt-4 footerHeader">
              <a href="/apartments/" target="_blank" style={{ color: "#FFFFFF", textDecoration: "none" }}>
                Apartments
              </a>
            </h3>

            <h4 className="footerNavSpace">
              <a className="footerLink" href="/forest-lake/encore-apartments/">
                Encore
              </a>
            </h4>

            <h4 className="footerNavSpace">
              <a className="footerLink" href="/forest-lake/gateway-green-apartments/">
                Gateway Green
              </a>
            </h4>

            <h4 className="footerNavSpace">
              <a className="footerLink" href="/forest-lake/mill-pond-apartments/">
                Mill Pond
              </a>
            </h4>

            <h4 className="footerNavSpace">
              <a className="footerLink" href="/forest-lake/birchview-apartments/">
                Birchview
              </a>
            </h4>

            <h4 className="footerNavSpace">
              <a className="footerLink" href="/forest-lake/legacy-pointe-apartments/">
                Legacy Pointe
              </a>
            </h4>

            <h4 className="footerNavSpace">
              <a className="footerLink" href="/forest-lake/heritage-heights-apartments/">
                Heritage Heights
              </a>
            </h4>

            <h4 className="footerNavSpace">
              <a className="footerLink" href="/apartments/">
                View more...
              </a>
            </h4>
          </div>

          <div className="col-3 col-md">
            <h3 className="footerHeader">
              <a href="/support/" target="_blank" style={{ color: "#FFFFFF", textDecoration: "none" }}>
                Residents
              </a>
            </h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/support/">
                    FAQ
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="https://norhart.twa.rentmanager.com">
                    Submit a Service Request
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/feedback/">
                    Feedback
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="https://norhart.twa.rentmanager.com" target="_blank">
                    Manage Account
                  </a>
                </h4>
              </li>
            </ul>

            <h3 className="footerHeader">Invest</h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/invest/">
                    Investment Platform
                  </a>
                </h4>
              </li>
            </ul>

            <h3 className="footerHeader">Podcasts</h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="https://podcasts.apple.com/us/podcast/zero-to-unicorn/id1685311966">
                    Follow and Listen
                  </a>
                </h4>
              </li>
            </ul>

            <h3 className="footerHeader">Design + Build</h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/labs/project-eve/">
                    Manufacturing
                  </a>
                </h4>
              </li>

              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/construction-crew/">
                    Construction
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/construction/">
                    Projects
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/construction-process/">
                    Lean
                  </a>
                </h4>
              </li>
            </ul>
          </div>

          <div className="col-3 col-md">
            <h3 className="footerHeader">
              <a href="/about/" target="_blank" style={{ color: "#FFFFFF", textDecoration: "none" }}>
                About
              </a>
            </h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/about/">
                    Leadership
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/vision/">
                    Our Vision
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/awards/">
                    Awards
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/giving-back/">
                    Giving Back
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="https://store.norhart.com">
                    Shop Swag
                  </a>
                </h4>
              </li>
            </ul>

            <h3 className="mt-4 footerHeader">
              <a href="/careers/" target="_blank" style={{ color: "#FFFFFF", textDecoration: "none" }}>
                Careers
              </a>
            </h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/recruiter-team/">
                    Recruiting Team
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/careers/">
                    Join Our Crew
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/interview-process/">
                    Interview Process
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/norhart-life/">
                    #NorhartCulture
                  </a>
                </h4>
              </li>

              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/benefits/">
                    Benefits
                  </a>
                </h4>
              </li>

              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/open-culture/">
                    Open Culture
                  </a>
                </h4>
              </li>
            </ul>

            <h3 className="mt-4 footerHeader">
              <a href="/blog/" target="_blank" style={{ color: "#FFFFFF", textDecoration: "none" }}>
                Blog
              </a>
            </h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="/blog/" target="_blank">
                    Read Posts
                  </a>
                </h4>
              </li>
            </ul>
          </div>

          <div className="col-3 col-md">
            <h3 className="footerHeader">Contact Us</h3>
            <ul className="list-unstyled text-small">
              <li>
                <h4 className="footerNavSpace">
                  <a
                    className="footerLink"
                    href="https://www.google.com/maps/place/Norhart/@45.2693772,-92.9894816,17z/data=!3m1!4b1!4m5!3m4!1s0x52b2e7ce8e90528b:0x1ea344204cfd768c!8m2!3d45.2693734!4d-92.9872876"
                    target="_blank"
                  >
                    <ApartmentIcon />
                    Norhart HQ
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a
                    className="footerLink ps-4"
                    href="https://www.google.com/maps/place/Norhart/@45.2693772,-92.9894816,17z/data=!3m1!4b1!4m5!3m4!1s0x52b2e7ce8e90528b:0x1ea344204cfd768c!8m2!3d45.2693734!4d-92.9872876"
                    target="_blank"
                  >
                    1081 4th St SW
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace ps-4">
                  <a
                    className="footerLink"
                    href="https://www.google.com/maps/place/Norhart/@45.2693772,-92.9894816,17z/data=!3m1!4b1!4m5!3m4!1s0x52b2e7ce8e90528b:0x1ea344204cfd768c!8m2!3d45.2693734!4d-92.9872876"
                    target="_blank"
                  >
                    Forest Lake, MN 55025
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace footerLink pt-3">
                  <ClockIcon />
                  M-F 9am-5pm
                </h4>
              </li>
              <li className="m-0"></li>
              <li>
                <h4 className="footerNavSpace">
                  <a
                    className="footerLink"
                    href="mailto:hello@norhart.com?subject= Norhart Sales Question"
                    target="_blank"
                  >
                    <MailIcon />
                    hello@norhart.com
                  </a>
                </h4>
              </li>
              <li>
                <h4 className="footerNavSpace">
                  <a className="footerLink" href="tel:651-689-4830" target="_blank">
                    <ContactPhoneIcon />
                    651-689-4830
                  </a>
                </h4>
              </li>
            </ul>
            <a href="/open-culture/">
              <NorhartTopWorkPlaces />
            </a>
          </div>
        </div>
      </footer>

      <footer className="container text-left pb-5">
        <div className="socialFooter">
          <a className="ms-1" target="_blank" href="https://www.instagram.com/norhartinc/">
            <span>
              <InstagramIcon />
            </span>
          </a>
          <a className="ms-1" target="_blank" href="https://www.linkedin.com/company/norhart/">
            <span>
              <LinkedInIcon />
            </span>
          </a>
          {/* <a className="ms-1" target="_blank" href="https://www.twitter.com/norhart">
            <span>
              <TwitterIcon />
            </span>
          </a> */}
          {/* <a className="ms-1" target="_blank" href="https://www.youtube.com/channel/UCqTrVU_Z1q2rcd8ejPstTgw">
            <span>
              <YouTubeIcon />
            </span>
          </a> */}
          <a className="ms-1" target="_blank" href="https://www.facebook.com/norhart">
            <span>
              <FacebookIcon />
            </span>
          </a>
        </div>

        <hr className="style-line mt-2 mb-4 ml-0 mr-0" style={{ borderColor: "rgba(0, 0, 0, 0.2)" }} />

        <span className="d-none d-sm-block" style={{ float: "right" }}>
          Designed with <HeartIcon /> in Minnesota
        </span>

        <div className="bottomFooter">
          <strong>©{getCurrentYear()} Norhart Inc</strong>
          <br />
        </div>

        <div className="bottomFooter opacity-75">
          <EqualHousingIcon />
          Equal Housing Opportunity
          <ul className="list-unstyled text-small">
            <li>
              <h4 className="footerNavSpace">
                <a className="footerLink" href="/legal/privacy/">
                  Privacy
                </a>
                <span className="footerLink"> | </span>{" "}
                <a className="footerLink" href="/legal/terms/">
                  Terms
                </a>
                <span className="footerLink"> | </span>{" "}
                <a className="footerLink" href="/security/">
                  Security
                </a>
              </h4>
            </li>
          </ul>
        </div>
      </footer>
      <Helmet>
        <link rel="preconnect" href="adx.dable.io" />
        <link rel="preconnect" href="https://tg.socdm.com" />
        <link rel="preconnect" href="https://adgen.socdm.com" />
        <link rel="preconnect" href="https://sync.ad-stir.com" />
        <script src="https://s.yimg.com/wi/ytc.js" defer={true}></script>
        <script src="https://connect.facebook.net/en_US/fbevents.js" defer={true}></script>
        <script
          src="https://connect.facebook.net/signals/config/376828226139532?v=2.9.45&amp;r=stable"
          defer={true}
        ></script>
        <script
          src="https://www.googletagmanager.com/gtag/js?id=G-ZWKZ00SK9F&amp;l=dataLayer&amp;cx=c"
          defer={true}
        ></script>
      </Helmet>
    </div>
  )
}

/** export */
export default Footer
